module.exports = __webpack_public_path__ + "img/logo.d19777c4.png";